import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    component: () => import("../components/layouts/Default.vue"),
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("../components/homePage/Home.vue"),
      },
      {
        path: "/photo/:id",
        name: "Photo page",
        component: () => import("../components/photos/Photo.vue"),
      },
      {
        path: "/s",
        name: "Search Page",
        component: () => import("../components/search/SearchWrapper.vue"),
        children: [
          {
            path: "/s/photos/:query",
            name: "photos",
            component: () => import("../components/search/Photos.vue"),
          },
          {
            path: "/s/users/:query",
            name: "users",
            component: () => import("../components/search/Users.vue"),
          },
          {
            path: "/s/collections/:query",
            name: "collections",
            component: () => import("../components/search/Collections.vue"),
          },
        ],
      },
      {
        path: "/user/:username",
        name: "User",
        component: () => import("../components/user/UserPage.vue"),
      },
      {
        path: "/collection/:id",
        name: "Collection",
        component: () => import("../components/collection/CollectionPage.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
